import { contentPagesApi } from "@/api/contentPagesApi";
import { safePrefetch } from "@/utils/prefetchUtils";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook for prefetching pages data
 * Automatically prefetches data for pages-related sections (interview guides, campaign pages, job pages)
 */
export const usePagesPrefetch = (user) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const isInPagesSection =
    location.pathname.startsWith("/employers/interview-guides") ||
    location.pathname.startsWith("/employers/campaign-pages") ||
    location.pathname.startsWith("/employers/job-pages");
  const shouldPrefetch = isInPagesSection && user?.employerId;

  // Prefetch campaign pages when in pages section using dispatch without subscription
  useEffect(() => {
    if (shouldPrefetch) {
      // Query parameters for prefetching campaign pages - match the default state of CampaignPagesTable
      const campaignPagesParams = {
        employerPermalink: user?.employerId,
        perPage: 50,
        cursor: null, // matches usePagination default
        searchQuery: "", // matches useSearch default (empty string, not null)
        types: [
          "sourcing_page",
          "careers_page",
          "job_page",
          "interview_overview",
          "meet_the_team",
          "onboarding",
          "event",
          "announcement",
          "blank",
          "culture_page",
        ],
      };

      safePrefetch(
        dispatch,
        contentPagesApi.endpoints.getContentPages.initiate,
        { ...campaignPagesParams }
      );
    }
  }, [shouldPrefetch, dispatch, user?.employerId]);
};
